import { render } from "./Nouns.vue?vue&type=template&id=2cd71454&ts=true"
import script from "./Nouns.vue?vue&type=script&lang=ts"
export * from "./Nouns.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__